import React, { useState } from 'react';
import { Box, TextField, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface ManualPlateInputProps {
  onSubmit: (plate: string) => void;
  loading?: boolean;
}

const ManualPlateInput: React.FC<ManualPlateInputProps> = ({ onSubmit, loading = false }) => {
  const [plate, setPlate] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (plate.trim() && !loading) {
      onSubmit(plate.trim().toUpperCase());
      setPlate('');
    }
  };

  const formatPlate = (value: string) => {
    // Auto-format: AB123CD -> AB-123-CD
    const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    
    if (clean.length <= 2) return clean;
    if (clean.length <= 5) return `${clean.slice(0, 2)}-${clean.slice(2)}`;
    return `${clean.slice(0, 2)}-${clean.slice(2, 5)}-${clean.slice(5, 7)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPlate(e.target.value);
    if (formatted.length <= 9) { // Max length AB-123-CD
      setPlate(formatted);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <TextField
        fullWidth
        value={plate}
        onChange={handleChange}
        placeholder="AB-123-CD"
        variant="outlined"
        disabled={loading}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton 
                type="submit" 
                edge="end" 
                disabled={!plate.trim() || loading}
                color="primary"
              >
                {loading ? <CircularProgress size={24} /> : <SearchIcon />}
              </IconButton>
            </InputAdornment>
          ),
          sx: { 
            fontSize: '1.2rem', 
            fontWeight: 500,
            height: 56
          }
        }}
      />
    </Box>
  );
};

export default ManualPlateInput;

